<template>
    <b-container class="m-0 p-0">
        <b-card class="p-2 w-100 bg-white" body-class="p-2 border rounded shadow-sm" v-if="Goal != undefined || Goal == {}">
            <!-- header-class="text-center p-0 w-100" -->
            <b-card-header @click="collapsed = !collapsed" role="tab" header-tag="header"
                           class="text-center font-weight-bold p-0 mx-0 w-100 bg-white">
                <b-row align-h="between" align-v="center">
                    <b-col class="text-left">
                        {{ $t('GoalN', { index : Index}) }} <!-- Objectif {{ Index }} -->
                    </b-col>
                    <b-col class="d-flex justify-content-end">
                        <b-button v-if="collapsed" size="sm" class="border-0 bg-white text-black">
                            <b-icon v-b-tooltip.hover :title="$t('Close')" icon="chevron-up" scale="1.5" role="button"/>
                        </b-button>

                        <b-button v-else size="sm" class="border-0 bg-white text-black">
                            <b-icon v-b-tooltip.hover :title="$t('Open')" icon="chevron-down" scale="1.5" role="button"/>
                        </b-button>

                        <b-button size="sm" class="border-0 bg-white">
                            <b-icon icon="x-lg" v-b-tooltip.hover :title="$t('DeleteGoalN', { index : Index })"
                                    @click.stop="$emit('RemoveDataBlockEvent', Index);" class="text-danger"/> <!-- // 'Supprimer \'Donnée ' +  Index + '\''  -->
                        </b-button>
                    </b-col>
                </b-row>

            </b-card-header>
            <b-collapse v-model="collapsed" accordion="dataAccordion">
                <b-card-body class="py-1">
                    <b-row class="text-muted" align-h="between">
                        <b-col class="font-weight-bold px-0" cols="4">
                            {{ $t('Name') }}
                        </b-col>
                        <b-col class="text-gray-dark text-left font-weight-bold px-0">
                            <b-row>
                                <b-col cols="1">
                                    <template v-if="Goal?.IsBench ?? false">
                                        <b-icon icon="diagram3" font-scale="1.5"/>
                                    </template>
                                    <template v-else>
                                        <b-icon icon="calculator" font-scale="1.5"/>
                                    </template>
                                </b-col>
                                <b-col>{{ Goal.Name }}</b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row class="text-muted" align-h="between">
                        <b-col class="text-gray-dark px-0" cols="4">
                            {{ $t('Node') }}
                        </b-col>
                        <b-col class="text-gray-dark text-left font-weight-bold px-0">
                            {{ Goal.NodeName }}
                        </b-col>
                    </b-row>
                    <b-row class="text-muted" align-h="between">
                        <b-col class="text-gray-dark px-0" cols="4">
                            {{ $t('Unit') }}
                        </b-col>
                        <b-col class="text-gray-dark text-left font-weight-bold px-0">
                            {{ Goal.Units?.join('/') }}
                        </b-col>
                    </b-row>
                    <b-row class="text-muted" align-h="between" v-if="!Goal?.IsBench ?? false">
                        <b-col class="text-gray-dark px-0" cols="4">
                            {{ $t('Periodicity') }}
                        </b-col>
                        <b-col class="text-gray-dark text-left font-weight-bold px-0">
                            {{
                                Goal.Dates != undefined && Goal.Dates.length > 0 ? $t("GoalPeriodicity" + Goal.Dates[Goal.Dates.length - 1].Periodicity) : ""
                            }}
                        </b-col>
                    </b-row>
                    <b-row class="text-muted" align-h="between" v-if="!Goal?.IsBench ?? false">
                        <b-col class="text-gray-dark px-0" cols="4">
                            {{  $t('Periods') }}
                        </b-col>
                        <b-col class="text-gray-dark text-left font-weight-bold px-0">
                            <template v-if="Goal.Dates != undefined && Goal.Dates.length > 0">
                                <template v-if="Goal.Dates[Goal.Dates.length - 1].StartDate != '0001-01-01T00:00:00'">
                                    {{ Goal.Dates[Goal.Dates.length - 1].StartDate | formatDate('DD/MM/YYYY') }}
                                </template>
                                <template v-else>
                                    -&infin;
                                </template>
                                -
                                <template
                                    v-if="Goal.Dates[Goal.Dates.length - 1].EndDate != '9999-12-31T23:59:59.9999999'">
                                    {{ Goal.Dates[Goal.Dates.length - 1].EndDate | formatDate('DD/MM/YYYY') }}
                                </template>
                                <template v-else>
                                    +&infin;
                                </template>
                            </template>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="text-gray-dark px-0" cols="4">
                            <template v-if="Goal?.IsBench ?? false">
                                {{  $t('Periods') }}
                            </template>
                        </b-col>
                        <b-col class="text-gray-dark text-left font-weight-bold px-0"
                               v-if="Goal.Dates != undefined">
                            <b-button variant="link" class="p-0" @click="periodVisible = true">{{ $t('ViewMore') }}</b-button> <!--  Voir + -->
                        </b-col>
                    </b-row>
                    <hr class="my-1 bg-gray"/>
                    <b-row class="text-muted" align-h="between">
                        <b-col class="font-weight-bold px-0" cols="4">
                            {{ $t('Cumulated') }} <!-- Cumulé -->
                        </b-col>
                        <b-col class="text-gray-dark text-left font-weight-bold px-0">
                            <b-form-checkbox switch v-model="dataValue.Cumulate"/>
                        </b-col>
                    </b-row>
                    <hr class="my-1 bg-gray"/>
                    <b-row class="text-muted" align-h="between">
                        <b-col class="font-weight-bold px-0">
                            {{ $t('InformationAdded') }} <!-- Informations ajoutées -->
                        </b-col>
                        <b-col class="d-flex justify-content-end px-2" cols="4">
                            <b-button variant="link" class="p-0" v-b-tooltip.hover
                                      @click="getAddedColumns();"
                                      :title="$t('AddInformationToCalculate')">
                                {{ $t('Add') }}
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row class="w-100 p-0 m-0 h-100 " align-v="center" v-if="dataValue.AddedColumns?.length > 0">
                        <table class="table m-0 p-0 align-middle" style="table-layout: fixed;">
                            <tr v-for="(column, index) in dataValue.AddedColumns" :key="index" class="mw-100">
                                <td class="p-1 text-gray-dark text-left text-truncate" v-b-tooltip.hover
                                    :title="getLabelAddedColumn(column)">
                                    {{ getLabelAddedColumn(column) }}
                                </td>
                                <td class="p-1 align-end" style="width: 20px">
                                    <b-icon @click="removeAddedColumns(index)" role="button" icon="x" scale="2"
                                            class="text-danger"/>
                                </td>
                            </tr>
                        </table>
                    </b-row>
                    <b-row class="text-muted" align-h="between" v-else>
                        <b-col class="text-gray-dark text-left font-italic px-0">
                            {{  $t('NoInformationAdded') }}  <!-- Aucune information ajoutée -->
                        </b-col>
                    </b-row>

                </b-card-body>
            </b-collapse>
            <!-- Affichage récapitulatif du DataBlock lors du collapse -->
            <b-collapse :visible="!collapsed" @shown="updateDataResume">
                <b-card-body class="py-1">
                    <b-row v-for="data in dataResume" :key="data.type" class="text-muted" align-h="between">
                        <b-col class="text-gray-dark px-0" cols="4">
                            {{ data.type }}
                        </b-col>
                        <b-col class="text-gray-dark text-left font-weight-bold px-0">
                            <b-row>
                                <b-col cols="1" v-if="data.icon">
                                    <b-icon :icon="data.icon" font-scale="1.5"/>
                                </b-col>
                                <b-col>{{ data.value }}</b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-collapse>
        </b-card>

        <!-- Pour l'affichage des périodes -->
        <b-modal :visible="periodVisible" no-close-on-backdrop centered size="lg" :variant="Variant">
            <template #modal-header="{close}">
                <b-col class="text-center">
                    <h6>{{ $t('PeriodGoalList', { name : Goal.Name }) }}</h6> <!-- Liste des périodes pour l'objectif : {{ Goal.Name }} -->
                </b-col>
                <b-col md="auto" class="text-right">
                    <b-icon-x-lg role="button" font-scale="1" @click="periodVisible = false; close();" v-b-tooltip.hover
                                 :title="$t('Close')"/>
                </b-col>
            </template>
            <b-row class="p-2">
                <b-table :id="$id('periodsItems')" selectable select-mode="multi" sort-desc :items="goalDates"
                         :fields="periodSearchFields" :no-select-on-click="periodVisible"
                         :per-page="periodItemPerPage" :current-page="periodCurrentPage">
                    <template #cell(StartDate)="date">
                        <template v-if="date.value != '0001-01-01T00:00:00'">
                            {{ date.value | formatDate('DD/MM/YYYY') }}
                        </template>
                        <template v-else>
                            -&infin;
                        </template>
                    </template>
                    <template #cell(EndDate)="date">
                        <template v-if="date.value != '9999-12-31T23:59:59.9999999'">
                            {{ date.value | formatDate('DD/MM/YYYY') }}
                        </template>
                        <template v-else>
                            +&infin;
                        </template>
                    </template>
                    <template #cell(Periodicity)="row">
                        {{ $t("GoalPeriodicity" + row.value) }}
                    </template>
                </b-table>
            </b-row>
            <template #modal-footer>
                <b-col>
                    <b-pagination v-if="Goal.Dates.length > 0" v-model="periodCurrentPage"
                                  :total-rows="Goal.Dates.length"
                                  :per-page="periodItemPerPage" class="mr-auto"/>
                </b-col>
                <b-col md="auto">
                    <b-button @click="periodVisible = false" :variant="'outline-' + Variant" pill
                              class="ml-auto m-2">{{ $t('Close') }}
                    </b-button>
                </b-col>
            </template>
        </b-modal>

        <!-- Pour l'affichage des informations ajoutées -->
        <b-modal :visible="infosVisible" no-close-on-backdrop centered size="lg" :variant="Variant">
            <template #modal-header="{close}">
                <b-col class="text-center">
                    <h6>{{ $t('InformationAddedList', {name : Goal.Name }) }}</h6> <!-- Liste des informations ajoutées : {{ Goal.Name }} -->
                </b-col>
                <b-col md="auto" class="text-right">
                    <b-icon-x-lg role="button" font-scale="1" @click="infosVisible = false; close();" v-b-tooltip.hover
                                 :title="$t('Close')"/>
                </b-col>
            </template>
            <b-row class="p-2 w-100">
                <b-form-checkbox-group :id="$id('selectedAdditionalInfos')" v-model="selectedAdditionalInfos"
                                       name="selectedAdditionalInfos" class="w-100">

                    <b-table :id="$id('infosItems')" selectable select-mode="multi" sort-desc :items="additionalInfo"
                             :fields="infosSearchFields" :no-select-on-click="infosVisible"
                             :per-page="infosItemPerPage" :current-page="infosCurrentPage">
                        <!-- Cellule permettant la sélection d'éléments via une case à cocher -->
                        <template #cell(Key)="key">
                            <b-form-checkbox :value="key.index" name="" class="m-0"/>
                        </template>
                        <template #cell(Type)="row">
                            {{ $t("GoalDatesType" + row.value) }}
                        </template>
                        <template #cell(Formula)="row">
                            <template v-if="row.value!=''">{{ $t("GoalDatesFormula" + row.value) }}</template>
                        </template>
                    </b-table>
                </b-form-checkbox-group>
            </b-row>
            <template #modal-footer>
                <b-col>
                    <b-pagination v-if="Goal.Dates.length > 0" v-model="infosCurrentPage"
                                  :total-rows="Goal.Dates.length"
                                  :per-page="infosItemPerPage" class="mr-auto"/>
                </b-col>
                <b-col md="auto">
                    <b-button @click="infosVisible = false; selectedAdditionalInfos = []"
                              :variant="'outline-' + Variant" pill class="ml-auto m-2">{{ $t('Close') }}
                    </b-button>
                    <b-button @click="updateAddedColumns()"
                              :disabled="!(additionalInfo.length > 0 && selectedAdditionalInfos?.length > 0)"
                              :variant="Variant" pill class="ml-auto">{{ $t('Validate') }}
                    </b-button>
                </b-col>
            </template>
        </b-modal>
    </b-container>
</template>

<script lang="ts">
import {Prop, PropSync, Vue, Watch} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import Component from 'vue-class-component';
import Dictionary from '@/types/Dictionary';
import axios from "axios";
import {API_URL} from "@/App.settings";
import draggable from 'vuedraggable';
import HscMenuStyleCustom from '@/components/commons/HscMenuStyleCustom';
import ListItem from "@/types/fields/ListItem";
import Multiselect from 'vue-multiselect';
import BasePeriod from '@/types/Config/BasePeriod';
import EnumItem from '@/types/fields/EnumItem';
import GoalData from '@/types/Config/GoalData';
/** Traductions */
import locales from './locales/DataBlockGoal.json';

/** Block de données de paramétrage */
@Component({
    components: {
        'hsc-menu-style-custom': HscMenuStyleCustom("secondary"),
        draggable,
        Multiselect,
    },
    i18n : { messages : locales }
})
export default class DataBlockGoal extends Vue {
    /** Variant de couleur à appliquer sur le composant */
    @Prop({default: () => "secondary"})
    public Variant!: string;

    /** Getter pour obtenir une liste */
    @Getter('GetListItems')
    private listItems!: (listName: string) => ListItem[];

    /** Getter pour obtenir une liste d'énumération */
    @Getter('GetListEnums')
    private listEnums!: (listName: string) => EnumItem[];

    /** Getter pour obtenir une liste filtrée selon le périmètre de l'utilisateur */
    @Getter('GetPerimeterItems')
    private perimeterItems!: (listName: string) => any[];

    /** Index du bloc de données */
    @Prop()
    public Index!: number;

    /** Données manipulées localement par le bloc de données */
    @PropSync('DataValue')
    public dataValue!: GoalData;

    private Goal: any = {};

    /** Indique sur le DataBlock est déplié ou replié */
    private collapsed: boolean = true;

    /** Text du résumé du DataBlock quand il est replié */
    private dataResume: { type: string, value: string, icon: string }[] = [];

    /**
     * Permet d'obtenir le resumé de la donnée quand elle est repliée
     */
    private updateDataResume() {
        // Réinitialisation
        this.dataResume = [];

        // Ajout des données
        this.dataResume.push({
            type: "Nom",
            value: this.Goal.Name,
            icon: this.Goal.IsBench ? 'diagram3' : 'calculator'
        });
        this.dataResume.push({type: this.$t('Node').toString(), value: this.Goal.NodeName, icon: undefined});
        this.dataResume.push({type: this.$t('Unit').toString(), value: this.Goal.Units?.join('/'), icon: undefined});
        this.dataResume.push({type: this.$t('Cumulated').toString(), value: this.dataValue.Cumulate ? this.$t('Yes').toString() : this.$t('No').toString(), icon: undefined});
        this.dataResume.push({
            type: this.$t('ShortInfoAdded').toString(), // "Infos ajoutées",
            value: this.$tc('InfoCount', this.dataValue.AddedColumns.length ), // this.addedColumns.length > 0 ? this.addedColumns.length + " information(s)" : "Aucune information",
            icon: undefined
        });
    }

    /** Liste les périodes renseignés dans la configuration */
    @Prop()
    public Periods!: BasePeriod[];


    /** Cumul des données */
    @PropSync("Cumulate", {default: () => false})
    public isCumulated!: boolean;
    // #endregion Affichage

    @Watch('GoalId', {immediate: true})
    private getGoal(){

        // Appel Server pour récupérer toutes les données de l'objectif sélectionné.
        // Ecran de chargement
        this.$store.dispatch("ShowLoadingMask",
            this.$t('RetrieveGoalInfo').toString(), {root: true}); // "Récupération des informations des objectifs en cours"

        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["GoalId"] = this.dataValue.GoalId;
        let goal: any= undefined;

        axios.post(API_URL + 'Goals/GetGoal', args).then((response) => {
            if (response && response.data) {
                console.debug("Goal - validSelection - axiosResult", response.data);

                let goals = response.data.Goal;
                if (goals != undefined && goals.length > 0) {
                    goal = goals[0];
                }
                this.$store.dispatch("HideLoadingMask", {});

                this.Goal = goal;
            }
            this.$store.dispatch("HideLoadingMask", {});
        }).catch(err => {
            console.error(err);
            this.$store.dispatch("HideLoadingMask", {}).then(() => {
                this.$bvToast.toast(this.$t('AnErrorOccuredContactAdmin').toString(), { // "Une erreur est survenue. Veuillez contacter votre administrateur."
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            });
        });
    }

    /** Permet de récupérer la liste des options avancées sélectionnées dans la configuration */
    @Watch('Goal')
    private getSelectedSettings() {
        if (this.Goal != undefined && ('IsBench' in this.Goal)) {
            let goals = [];
            if (this.Goal.IsBench)
                goals = [...this.Goal.Goals];
            else
                goals.push(this.Goal);

            this.additionalInfo = [];
            this.goalDates = [];

            for (let i = 0; i < goals.length; i++) {
                goals[i].Dates.forEach((a) => {
                    a.Meters.forEach((b) => {
                        let inGoal: boolean = a.FormulaGoal.includes('[M:' + b.Id + ']');
                        let inReal: boolean = a.FormulaReal.includes('[M:' + b.Id + ']');
                        let index = this.additionalInfo.findIndex(a => a.Data.PersistentRef == b.PersistentRef);
                        if (index >= 0) {
                            this.additionalInfo[index].InGoal = inGoal || this.additionalInfo[index].InGoal;
                            this.additionalInfo[index].InReal = inReal || this.additionalInfo[index].InReal;
                            this.additionalInfo[index].Key.push({DateId: a.Id, Id: b.Id, Type: 'Meter'});
                        } else {
                            this.additionalInfo.push(new AdditionalInfo(inGoal, inReal, 'Meter',
                                [{DateId: a.Id, Id: b.Id, Type: 'Meter'}], b.Code, b.Designation, b));
                        }
                    });

                    a.Factors.forEach((b) => {
                        let inGoal: boolean = a.FormulaGoal.includes('[F:' + b.Id + ']');
                        let inReal: boolean = a.FormulaReal.includes('[F:' + b.Id + ']');
                        let index = this.additionalInfo.findIndex(a => a.Data.Code == b.Code);
                        if (index >= 0) {
                            this.additionalInfo[index].InGoal = inGoal || this.additionalInfo[index].InGoal;
                            this.additionalInfo[index].InReal = inReal || this.additionalInfo[index].InReal;
                            this.additionalInfo[index].Key.push({DateId: a.Id, Id: b.Id, Type: 'Factor'});
                        } else {
                            this.additionalInfo.push(new AdditionalInfo(inGoal, inReal, 'Factor',
                                [{DateId: a.Id, Id: b.Id, Type: 'Factor'}], b.Code, b.Designation, b));
                        }
                    });

                    a.ContractualDatas.forEach((b) => {
                        let index = this.additionalInfo.findIndex(a => a.Data.m_Item2 == b.m_Item2);
                        if (index >= 0) {
                            this.additionalInfo[index].Key.push({DateId: a.Id, Id: b.m_Item1, Type: 'ContractualData'});
                        } else {
                            this.additionalInfo.push(new AdditionalInfo(false, false,
                                'ContractualData', [{DateId: a.Id, Id: b.m_Item1, Type: 'ContractualData'}],
                                null, b.m_Item2, b));
                        }
                    });

                    a.Constants.forEach((b) => {
                        let inGoal: boolean = a.FormulaGoal.includes('{C:' + b.m_Item1 + '}');
                        let inReal: boolean = a.FormulaReal.includes('{C:' + b.m_Item1 + '}');
                        let index = this.additionalInfo.findIndex(a => a.Data.m_Item2 == b.m_Item2);
                        if (index >= 0) {
                            this.additionalInfo[index].InGoal = inGoal || this.additionalInfo[index].InGoal;
                            this.additionalInfo[index].InReal = inReal || this.additionalInfo[index].InReal;
                            this.additionalInfo[index].Key.push({DateId: a.Id, Id: b.m_Item1, Type: 'Constant'});
                        } else {
                            this.additionalInfo.push(new AdditionalInfo(inGoal, inReal, 'Constant',
                                [{DateId: a.Id, Id: b.m_Item1, Type: 'Constant'}], null, b.m_Item2, b));
                        }
                    });

                    this.goalDates.push(a);
                });
            }
        }
    }

    private removeAddedColumns(index: number) {
        this.dataValue.AddedColumns.splice(index, 1);
    }

    private getLabelAddedColumn(key) {
        let allKey: { DateId: number, Id: number, Type: string, Index: number }[] = [];
        this.additionalInfo.map((a, i) =>
            a.Key.forEach((b) => allKey.push({DateId: b.DateId, Id: b.Id, Type: b.Type, Index: i})));

        let index = allKey.find(a =>
            a.Id == key.Keys[0].Id && a.Type == key.Keys[0].Type && a.DateId == key.Keys[0].DateId)?.Index;
        let addColumn = this.additionalInfo[index];
        if (addColumn != undefined)
        return (addColumn.Formula == "" ? "-" :
                addColumn.Formula.replace('Real', this.$t('GoalDatesFormulaReal').toString())).replace('Goal', this.$t('GoalDatesFormulaGoal').toString()).replace('_', '/') // 'Réel' | 'Objectif'
            + " : " + addColumn.Name;
        return  '';
    }

    private getAddedColumns(){
        this.selectedAdditionalInfos = this.dataValue.AddedColumns.map(a=> a.Index);
        this.infosVisible = true;
    }

    //#region Modal des périodes
    private goalDates: any[] = [];
    private periodCurrentPage: number = 1;
    private periodItemPerPage: number = 8;
    private periodVisible: boolean = false;

    private selectedAdditionalInfos: number[] = [];

    /** Tableau des entêtes du tableau */
    private periodSearchFields = [
        {key: "StartDate", label: this.$t('From').toString(), sortable: true}, // "Du"
        {key: "EndDate", label: this.$t('To').toString(), sortable: true}, // "Au"
        {key: "Periodicity", label: this.$t('Periodicity').toString(), sortable: true}, //  "Périodicité"
        {
            key: "IndexInRange", label: this.$t('Index').toString(), sortable: false, formatter: value => { // "Index"
                return value ? this.$t('Yes').toString() : this.$t('No').toString();
            }
        },
    ]
    //#endregion

    //#region Modal des informations ajoutées
    private additionalInfo: AdditionalInfo[] = [];
    private infosCurrentPage: number = 1;
    private infosItemPerPage: number = 8;
    private infosVisible: boolean = false;

    /** Tableau des entêtes du tableau */
    private infosSearchFields = [
        {key: "Key", label: "", ThStyle: "width:20px"},
        {key: "Formula", label: this.$t('Formula').toString(), sortable: true}, //  "Formule"
        {key: "Type", label: this.$t('Type').toString(), sortable: true},
        {key: "Code", label: this.$t('Code').toString(), sortable: true},
        {key: "Name", label: this.$t('NameOrDesignation').toString(), sortable: true}, // "Nom / Désignation"
    ];

    private updateAddedColumns(){
        let addedColumns = [];
        for(let i =0; i< this.selectedAdditionalInfos.length; i++)        {
            addedColumns.push({ Keys: this.additionalInfo[this.selectedAdditionalInfos[i]].Key, Index: this.selectedAdditionalInfos[i] });
        }
        Vue.set(this, 'addedColumns', addedColumns);
        this.selectedAdditionalInfos = [];
        this.infosVisible = false;
    }

    //endregion

    created() {
    }

    mounted() {
        /** Chargement des options sélectionnées */
        this.getGoal();
    }
}


class AdditionalInfo {
    public InGoal: boolean;
    public InReal: boolean;
    public Type: string;
    public Key: { DateId: number, Id: number, Type: string }[];
    public Code: string;
    public Name: string;
    public Data: any;

    public get Formula() {
        let inValue: string = (this.InGoal ? 'Goal' : '');
        inValue = inValue + (this.InReal ? (inValue == '' ? '' : '_') + 'Real' : '');
        return inValue;
    }

    constructor(inGoal: boolean, inReal: boolean, type: string, key: { DateId: number, Id: number, Type: string }[],
                code: string, name: string, data: any) {
        this.InGoal = inGoal;
        this.InReal = inReal;
        this.Type = type;
        this.Key = key;
        this.Code = code;
        this.Name = name;
        this.Data = data;
    }
}

</script>

<style scoped>

/* Permet aux en-tetes des b-card d'afficher le curseur comme sur un bouton */
.card-header:hover {
    cursor: pointer;
}
</style>